export default __webpack_public_path__ + "static/media/card-2.e8e49579.svg";